@if (isSlowConnection) {
  <div class="alert">
    ⚠ La conexión de internet es lenta.
  </div>
}

<app-page-title [title]="title()"></app-page-title>
<app-page-loader [load]="pageLoad" [label]="title()" (retry)="init()"></app-page-loader>

<div class="header">
<!-- Selector de sitio → almacén, indicadores y cambio de vista.
     El selector es el del toolbar, igual que en Inventario de instrumental,
     para que los tres módulos se vean y se usen igual. Sustituyó a la
     tarjeta-acordeón "Selección de almacén" que había aquí; `inventoryForm`
     se conserva porque el resto del componente lee de ahí el almacén, pero
     ahora lo llena `onScopeChange()`. -->
<app-inventory-toolbar
  [places]="placeList"
  [warehouses]="warehouseList"
  [kpis]="kpis"
  [activeKpi]="activeKpi"
  [viewMode]="viewMode"
  storageKey="equipments"
  [showViewToggle]="false"
  [useWarehouse]="false"
  (scopeChange)="onScopeChange($event)"
  (kpiToggle)="onKpiToggle($event)"
  (viewModeChange)="onViewModeChange($event)">
</app-inventory-toolbar>



  <div class="filter-bar">
    <div class="filter-card">
      <app-search-pill placeholder="Código, descripción, lote, RFID…" (search)="applyFilter($event)"></app-search-pill>
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Estatus de inventario</mat-label>
        <mat-select [(value)]="invStatus" (selectionChange)="statusFilter($event)">
          <mat-option value="Limpiar">Todos</mat-option>
          @for (status of statuses; track status) {
            <mat-option [value]="status">{{status}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <span class="filter-card__spacer"></span>
      <mat-button-toggle-group class="view-toggle" [value]="viewMode" (change)="onViewModeChange($event.value)" [hideSingleSelectionIndicator]="true" aria-label="Vista">
        <mat-button-toggle value="table" matTooltip="Vista de tabla"><mat-icon>table_rows</mat-icon></mat-button-toggle>
        <mat-button-toggle value="cards" matTooltip="Vista de tarjetas"><mat-icon>grid_view</mat-icon></mat-button-toggle>
      </mat-button-toggle-group>
    </div>
    <app-filter-chips [chips]="statusChips" [count]="dataSource?.filteredData?.length" [total]="dataSource?.data?.length" noun="equipos" (remove)="clearStatus()" (clear)="clearStatus()"></app-filter-chips>
  </div>


</div>


<div class="list-actions">
  <button mat-stroked-button (click)="pageLoad.refresh(search())"><mat-icon>refresh</mat-icon> Actualizar</button>
  <button mat-stroked-button [matMenuTriggerFor]="menu"><mat-icon>table_view</mat-icon> Excel y más</button>
  <mat-menu #menu="matMenu">
    @if (permissions?.create) {
      <button mat-menu-item (click)="openUploadFile()"><mat-icon>upload</mat-icon>Cargar inventario (xlsx)</button>
    }
    <button mat-menu-item (click)="downloadFile()"><mat-icon>download</mat-icon>Descargar inventario (xlsx)</button>
    @if (permissions?.create) {
      <button mat-menu-item (click)="downloadSampleFile()"><mat-icon>description</mat-icon>Plantilla de carga</button>
    }
    @if (permissions?.update) {
      <button mat-menu-item (click)="downloadSampleMaintenanceScheduleFile()"><mat-icon>description</mat-icon>Plantilla de carga de calendario de mantenimientos</button>
    }
    @if (permissions?.update) {
      <button mat-menu-item (click)="openUpdateMaintenanceFile()"><mat-icon>upload</mat-icon>Cargar Mantenimientos (xlsx)</button>
    }
    <button mat-menu-item (click)="openMaintenanceCalendar()"><mat-icon>calendar_today</mat-icon>Calendario de mantenimiento</button>
  </mat-menu>
  @if (permissions?.create&&this.inventoryForm.controls['warehouse'].value !== 'Todos') {
    <button mat-flat-button color="primary" [disabled]="btnSelectionWarehouse" (click)="openForm('create','Propio')"><mat-icon>add</mat-icon>Agregar inventario</button>
  }
</div>

@if (scopeReady) {
  <app-selection-bar [count]="selection.selected.length" (export)="exportSelection()" (clear)="selection.clear()"></app-selection-bar>
}

@if (scopeReady) {
<div class="indicators">
  <div class="dark-status">
    <span><b>Mostrando: {{dataSource ? dataSource?.filteredData.length : 0}}</b></span>
  </div>
  <mat-paginator class="spacer" [pageSizeOptions]="[50]"></mat-paginator>
</div>

<mat-divider></mat-divider>


<!-- ── Vista de tarjetas ─────────────────────────────────────────── -->
@if (viewMode === 'cards') {
  <div class="inv-cards cat-cards">
    @for (item of dataSource?.filteredData ?? []; track item.id) {
      <div class="cat-card" [class.cat-card--selected]="selection.isSelected(item)">
        <div class="cat-card__photo">
          @if (item._image) {<img [src]="item._image" alt="Foto" loading="lazy" (click)="openImage(item._image)">} @else {<mat-icon>image_not_supported</mat-icon>}
        </div>
        <div class="cat-card__head">
          <mat-checkbox color="primary" [checked]="selection.isSelected(item)" (change)="selection.toggle(item)" matTooltip="Seleccionar"></mat-checkbox>
          <span class="cat-card__title">{{ equipmentObj[item.equipment]?.['code'] || 'Sin equipo' }}</span>
          <span class="inv-status" [attr.data-status]="item.status">{{ item.status || '—' }}</span>
        </div>
        <div class="cat-card__body">
            <div class="cat-card__field"><span class="cat-card__label">Responsable:</span><span class="cat-card__value">{{ equipmentObj[item.equipment]?.['description'] || '—' }}</span></div>
            <div class="cat-card__field"><span class="cat-card__label">Serie:</span><span class="cat-card__value">{{ item.serialNumber || '—' }}</span></div>
            <div class="cat-card__field"><span class="cat-card__label">Usos:</span><span class="cat-card__value">{{ item.numberUses ?? 0 }}</span></div>
            <div class="cat-card__field"><span class="cat-card__label">Lote:</span><span class="cat-card__value">{{ item.batch || '—' }}</span></div>
            <div class="cat-card__field"><span class="cat-card__label">RFID:</span><span class="cat-card__value">{{ item.tagRfid || '—' }}</span></div>
            <div class="cat-card__field"><span class="cat-card__label">Año:</span><span class="cat-card__value">{{ item.manufacturerYear || '—' }}</span></div>
            <div class="cat-card__field"><span class="cat-card__label">Ubicación:</span><span class="cat-card__value">{{ item.location ? (placeObj?.[item.location] ?? '—') : '—' }}</span></div>
            <div class="cat-card__field"><span class="cat-card__label">Tipo:</span><span class="cat-card__value">{{ item.type || '—' }}</span></div>
        </div>
        <div class="cat-card__actions">
          @if (permissions?.update) {
            <button mat-icon-button color="primary" matTooltip="Cambio de estado" (click)="openChangeStatus(item)"><mat-icon>autorenew</mat-icon></button>
          }
          <button mat-icon-button color="primary" matTooltip="Editar fecha entrada y salida" (click)="openEntryExitData(item)"><mat-icon>schedule_send</mat-icon></button>
          <button mat-icon-button color="primary" matTooltip="Mantenimiento" (click)="openMaintenanceSchedule(item)"><mat-icon>calendar_today</mat-icon></button>
          @if (isSonicision(item)) {
            <button mat-icon-button color="primary" matTooltip="Bitácora SONICISION (PDF)" (click)="downloadSonicisionLog(item)"><mat-icon>menu_book</mat-icon></button>
          }
          <button mat-icon-button color="primary" matTooltip="Ordenes de servicio" (click)="openMaintenanceDone(item)"><mat-icon>note_add</mat-icon></button>
          @if (permissions?.update) {
            <button mat-icon-button color="primary" matTooltip="Editar" (click)="openForm('update', null, item)"><mat-icon>edit</mat-icon></button>
          }
          @if (permissions?.delete) {
            <button mat-icon-button color="warn" matTooltip="Eliminar" (click)="remove(item)"><mat-icon>delete</mat-icon></button>
          }
        </div>
      </div>
    }
    @if ((dataSource?.filteredData ?? []).length === 0) {
      <p class="inv-cards__empty">No hay equipos que coincidan con el filtro.</p>
    }
  </div>
}

<div class="table-container mat-elevation-z8" [hidden]="viewMode !== 'table'">

  <table mat-table [dataSource]="dataSource">

        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef class="select-cell">
            <mat-checkbox color="primary" (change)="$event ? toggleAllRows() : null" [checked]="isAllSelected()" [indeterminate]="isPartiallySelected()" matTooltip="Seleccionar todos los visibles"></mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let row" class="select-cell">
            <mat-checkbox color="primary" (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)"></mat-checkbox>
          </td>
        </ng-container>

        <ng-container matColumnDef="photo">
          <th mat-header-cell *matHeaderCellDef class="photo-cell"> Foto </th>
          <td mat-cell *matCellDef="let e" class="photo-cell">
            <span class="inv-thumb">@if (e._image) {<img [src]="e._image" alt="Foto" loading="lazy" (click)="openImage(e._image)">} @else {<mat-icon>image_not_supported</mat-icon>}</span>
          </td>
        </ng-container>

    <!-- product Column -->
    <ng-container matColumnDef="equipment">
      <th mat-header-cell *matHeaderCellDef> Equipo </th>
      <td mat-cell *matCellDef="let element; let i=index;">
        {{ element.equipment ? equipmentObj[element.equipment]?.['code'] : '' }}
      </td>
    </ng-container>

    <!-- itemNumber Column -->
    <ng-container matColumnDef="itemNumber">
      <th mat-header-cell *matHeaderCellDef> Partida </th>
      <td mat-cell *matCellDef="let element; let i=index;">
        {{ element.equipment ? equipmentObj[element.equipment]?.['itemNumber']?.[activeContract.id] : 'Sin partida' }}
      </td>
    </ng-container>

    <!-- description Column -->
    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef> Responsable del equipo </th>
      <td mat-cell *matCellDef="let element; let i=index;">
        {{ element.equipment ? equipmentObj[element.equipment]?.['description'] : '' }}
      </td>
    </ng-container>

    <!-- serialNumber Column -->
    <ng-container matColumnDef="serialNumber">
      <th mat-header-cell *matHeaderCellDef> Número de serie </th>
      <td mat-cell *matCellDef="let element; let i=index;">
        {{ element.serialNumber }}
      </td>
    </ng-container>

    <!-- manufacturer Column -->
    <ng-container matColumnDef="manufacturer">
      <th mat-header-cell *matHeaderCellDef> Marca </th>
      <td mat-cell *matCellDef="let element; let i=index;">
        {{ element.equipment ? equipmentObj[element.equipment]?.['manufacturer'] : '' }}
      </td>
    </ng-container>

    <!-- manufacturerYear Column -->
    <ng-container matColumnDef="manufacturerYear">
      <th mat-header-cell *matHeaderCellDef> Año de fabricación </th>
      <td mat-cell *matCellDef="let element; let i=index;">
        {{ element.manufacturerYear }}
      </td>
    </ng-container>

    <!-- batch Column -->
    <ng-container matColumnDef="batch">
      <th mat-header-cell *matHeaderCellDef> Lote </th>
      <td mat-cell *matCellDef="let element"> {{ element.batch ?? '' }} </td>
    </ng-container>

    <!-- ownershipType Column -->
    <ng-container matColumnDef="ownershipType">
      <th mat-header-cell *matHeaderCellDef> Tipo de propiedad </th>
      <td mat-cell *matCellDef="let element"> {{ element.ownershipType ?? '' }} </td>
    </ng-container>

    <!-- location Column -->
    <ng-container matColumnDef="location">
      <th mat-header-cell *matHeaderCellDef> Alias (ubicación) </th>
      <td mat-cell *matCellDef="let element"> {{ element.location ? (placeObj?.[element.location] ?? '') : '' }} </td>
    </ng-container>

    <!-- locationResponsible Column -->
    <ng-container matColumnDef="locationResponsible">
      <th mat-header-cell *matHeaderCellDef> Responsable en ubicación </th>
      <td mat-cell *matCellDef="let element"> {{ element.locationResponsible ?? '' }} </td>
    </ng-container>

    <!-- warranty Column -->
    <ng-container matColumnDef="warranty">
      <th mat-header-cell *matHeaderCellDef> Garantía </th>
      <td mat-cell *matCellDef="let element">
        @if (element.warrantyNumber || element.warrantyStart || element.warrantyEnd) {
          {{ element.warrantyNumber ?? '' }}
          @if (element.warrantyStart || element.warrantyEnd) {
            <br><small>{{ element.warrantyStart ?? '¿?' }} → {{ element.warrantyEnd ?? '¿?' }}</small>
          }
        }
      </td>
    </ng-container>

    <!-- tagRfid Column -->
    <ng-container matColumnDef="numberUses">
      <th mat-header-cell *matHeaderCellDef> Usos </th>
      <td mat-cell *matCellDef="let element"> {{ element.numberUses ?? 0 }} </td>
    </ng-container>

    <ng-container matColumnDef="tagRfid">
      <th mat-header-cell *matHeaderCellDef> Etiqueta RFID </th>
      <td mat-cell *matCellDef="let element; let i=index;">
        {{ element.tagRfid }}
      </td>
    </ng-container>

    <!-- createdOn Column -->
    <ng-container matColumnDef="createdOn">
      <th mat-header-cell *matHeaderCellDef> Fecha de ingreso </th>
      <td mat-cell *matCellDef="let element; let i=index;">
        {{ element.createdOn | date: 'd/M/y' }}
      </td>
    </ng-container>

    <!-- type Column -->
    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef> Tipo de producto </th>
      <td mat-cell *matCellDef="let element; let i=index;">
        {{ element.type }}
      </td>
    </ng-container>

    <!-- status Column -->
    <ng-container matColumnDef="status" stickyEnd>
      <th mat-header-cell *matHeaderCellDef> Estatus </th>
      <td mat-cell *matCellDef="let element; let i=index;">
        <div [ngClass]="{'Activo' : 'green-status', 'Baja' : 'red-status', 'Mantenimiento' : 'yellow-status'}[element.status]">
          {{ element.status }}
        </div>
      </td>
    </ng-container>

    <!-- more Column -->
    <ng-container matColumnDef="more" stickyEnd>
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element; let i=index;">
        @if (permissions?.update) {
          <button
            mat-icon-button
            color="primary"
            matTooltip="Cambio de estado"
            (click)="openChangeStatus(element)" >
            <mat-icon>autorenew</mat-icon>
          </button>
        }
        <button
          mat-icon-button
          color="primary"
          matTooltip="Editar fecha entrada y salida"
          (click)="openEntryExitData(element)" >
          <mat-icon>schedule_send</mat-icon>
        </button>
        <button
          mat-icon-button
          color="primary"
          matTooltip="Mantenimiento"
          (click)="openMaintenanceSchedule(element)" >
          <mat-icon>calendar_today</mat-icon>
        </button>
        @if (isSonicision(element)) {
          <button mat-icon-button color="primary" matTooltip="Bitácora SONICISION (PDF)" (click)="downloadSonicisionLog(element)">
            <mat-icon>menu_book</mat-icon>
          </button>
        }
        <button
          mat-icon-button
          color="primary"
          matTooltip="Ordenes de servicio"
          (click)="openMaintenanceDone(element)" >
          <mat-icon>note_add</mat-icon>
        </button>
        @if (permissions?.update) {
          <button
            mat-icon-button
            color="primary"
            matTooltip="Editar"
            (click)="openForm('update', null, element)" >
            <mat-icon>edit</mat-icon>
          </button>
        }

        @if (permissions?.delete) {
          <button
            mat-icon-button
            color="warn"
            matTooltip="Eliminar"
            (click)="remove(element)" >
            <mat-icon>delete</mat-icon>
          </button>
        }
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
</div>
}
